import React, { useState } from 'react'
import { Box, Typography, Paper, Tabs, Tab, Button } from '@mui/material'
import { ArrowBack as ArrowBackIcon, MenuBook as TermsIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import CustomerLayout from '@/components/Layout/CustomerLayout'

export const TermsPage: React.FC = () => {
  const navigate = useNavigate()
  const [tabValue, setTabValue] = useState(0)

  return (
    <CustomerLayout>
      <Box sx={{ maxW: 900, mx: 'auto' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/checkout')} sx={{ mb: 2 }}>
          ご注文画面へ戻る
        </Button>

        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: '1px solid #e2e8f0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <TermsIcon color="primary" sx={{ fontSize: 32 }} />
            <Typography variant="h5" fontWeight={700}>
              規約・プライバシーポリシー
            </Typography>
          </Box>

          <Tabs value={tabValue} onChange={(_, val) => setTabValue(val)} sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tab label="利用規約" sx={{ fontWeight: 700 }} />
            <Tab label="プライバシーポリシー（個人情報保護方針）" />
          </Tabs>

          {tabValue === 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Typography variant="h6" fontWeight={700}>
                HighLandirect オンライン注文 利用規約
              </Typography>

              <Typography variant="body2">
                本利用規約（以下「本規約」）は、HighLandirect（以下「当サービス」）が提供するオンライン注文システムの利用条件を定めるものです。ユーザーの皆様は、本規約に同意の上で当サービスをご利用ください。
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                第1条（アカウントおよび認証）
              </Typography>
              <Typography variant="body2" color="text.secondary">
                当サービスの利用にはGoogleアカウントによる認証（Google Sign-In）が必要です。ユーザーは自身のGoogleアカウントの管理責任を負うものとします。
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                第2条（売買契約の成立および決済タイミング）
              </Typography>
              <Typography variant="body2" color="text.secondary">
                1. ユーザーが注文手続き画面にて所定の入力を完了し、Stripe決済画面にて与信確保（仮売上）が成功した時点で、当サービスとユーザーとの間に注文受付が完了します。<br />
                2. <strong>決済手続きはオーソリ（仮売上・与信枠確保）方式を採用</strong>しております。実際の引き落とし（実売上・売上確定）は、商品の出荷完了時または配達完了時に実行されます。
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                第3条（配送および送料）
              </Typography>
              <Typography variant="body2" color="text.secondary">
                1. 商品の配送はヤマト運輸等の提携配送業者により行われます。<br />
                2. 配送料金はお届け先地域および注文商品の合計重量に応じて自動計算され、最終確認画面に表示されます。
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                第4条（キャンセル・不可抗力）
              </Typography>
              <Typography variant="body2" color="text.secondary">
                商品発送手続き完了前であればキャンセルの受付が可能です。発送手続き完了後のキャンセルにつきましては特定商取引法に基づく表記の通りお受けできません。天災地変等の不可抗力により配送不能となった場合は、与信枠を開放し全額返金対応を行います。
              </Typography>
            </Box>
          )}

          {tabValue === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Typography variant="h6" fontWeight={700}>
                個人情報保護方針（プライバシーポリシー）
              </Typography>

              <Typography variant="body2">
                当サービスは、ユーザーの個人情報の重要性を認識し、個人情報保護法に基づき適切に取り扱います。
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                1. 収集する個人情報
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ・Googleアカウント認証により取得する情報（氏名、メールアドレス、プロフィール画像）<br />
                ・ご注文時にご入力いただく情報（お名前、フリガナ、配送先住所、電話番号）<br />
                ・決済に関する識別情報（Stripe PaymentIntent ID / Session ID）
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                2. 利用目的
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ・注文商品の配送およびこれに付随するご連絡<br />
                ・クレジットカード決済処理（Stripe連携）および売上確定処理<br />
                ・お問い合わせ対応、マイ配送先リストの保持
              </Typography>

              <Typography variant="subtitle2" fontWeight={700}>
                3. 第三者への委託・提供
              </Typography>
              <Typography variant="body2" color="text.secondary">
                当サービスは、以下の配送業者および決済代行業者に必要な範囲で個人情報を提供・委託します。<br />
                ・<strong>決済代行</strong>: Stripe, Inc.（クレジットカード情報の非保持化・安全な与信確保のため）<br />
                ・<strong>配送業者</strong>: ヤマト運輸株式会社 等（伝票発行・商品配送のため）
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </CustomerLayout>
  )
}
export default TermsPage
